import { useEffect, useMemo, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

import AccountService from "src/Services/API/account.service";

function AccountDropdown({
  onSelect = () => { },
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("Select customer");

  useEffect(() => {
    const loadAccounts = async () => {
      try {
        const response = await AccountService.getAll();
        if (response.status === 200) {
          setAccounts(response.data || []);
        }
      } catch (error) {
        console.log("Account dropdown load error: ", error);
      }
    };

    loadAccounts();
  }, []);

  const filteredAccounts = useMemo(() => {
    const normalizedKeyword = keyword.trim().toLowerCase();

    return accounts.filter((account) => {
      if (!normalizedKeyword) {
        return true;
      }

      return (account.name || "").toLowerCase().includes(normalizedKeyword);
    });
  }, [accounts, keyword]);

  const handleAccountClick = (index) => {
    const selectedAccount = filteredAccounts[index];
    setSelectedLabel(selectedAccount?.name || "Select customer");
    setIsOpen(false);
    onSelect(selectedAccount, index);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="cursor-pointer w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500"
        >
          <span className="font-OpenSansRegular text-[12px] text-titleColor truncate">
            {selectedLabel}
          </span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            <div className="w-full h-[30px] border-solid border-b-[1px] flex items-center justify-center px-[15px]">
              <input
                value={keyword}
                type="text"
                onChange={(event) => {
                  setKeyword(event.target.value);
                }}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Search..."
              />
            </div>
            {filteredAccounts.map((account, index) => (
              <li
                key={account.id ?? index}
                onClick={() => handleAccountClick(index)}
                className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
              >
                {account.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default AccountDropdown;
